import React, { Component } from 'react';
import { Button, Col, Row } from 'react-bootstrap';

import ComercioExteriorDomicilioForm from './ComercioExteriorDomicilioForm';

class ComercioExteriorDestinatarioDomicilioForm extends Component {
  state = {};

  constructor(props) {
    super(props);

    this.state = {
      data: {},
      isValid: false,
    };
  }

  componentDidUpdate() {
    const { data } = this.props;

    if (!!data) {
      this.setState({
        data: { ...data },
        isValid: true,
      });
    }
  }

  handleOnAdd = () => {
    this.props.onAdd(this.state.data);

    this.setState({
      isValid: false,
      data: {}
    })
  }

  handleOnDomicilioDataChange = (event) => {
    const data = {
      ...this.state.data.Domicilio,
      ...event.data,
    }

    this.setState({
      data: {
        ...this.state.data,
        Domicilio: data,
      },
      isValid: event.isValid,
      isTouchedDomicilio: event.isTouched
    });
  }

  render() {
    const { isValid, data = {} } = this.state;

    return (
      <>
        <ComercioExteriorDomicilioForm
          data={ data.Domicilio || {} }
          required
          onFormDataChange={ this.handleOnDomicilioDataChange }
        />

        <Row>
          <Col>
            <p className="text-muted">
              Puedes agregar Domicilio usando el botón "Agregar Domicilio", la lista se mostrarán en la tabla de Domicilios.
            </p>
          </Col>
        </Row>

        <Row className="py-3">
          <Col className="text-right">
            <Button variant="secondary"
              disabled={ !isValid }
              onClick={ this.handleOnAdd }
            >
              Agregar Domicilio
            </Button>
          </Col>
        </Row>
      </>
    )
  }
}

export default ComercioExteriorDestinatarioDomicilioForm;